import { render, staticRenderFns } from "./AddFileModal.vue?vue&type=template&id=60d37017&scoped=true&"
import script from "./AddFileModal.vue?vue&type=script&lang=js&"
export * from "./AddFileModal.vue?vue&type=script&lang=js&"
import style0 from "./AddFileModal.vue?vue&type=style&index=0&id=60d37017&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d37017",
  null
  
)

export default component.exports